import React from 'react';
import './OurDoctors.css';

const OurDoctors = () => {
  const doctorData = {
    name: "DR. GARLAPATI SIVA SRIKAR",
    role: "Chief Consultant Orthopaedic & Joint Replacement Surgeon",
    imageUrl: "/Doc-aboutImage.png" // Replace with actual image path
  };

  return (
    <section className="doctors-section">
      <div className="header-content">
        <h1>Our Doctors</h1>
        <p>
          Our team of orthopedic doctors lead by Dr. Garlapati Siva Srikar is one of the best team for 
          orthopedic surgeons in Guntur. Our team has over 10+ years of experience in 
          treating orthopedic conditions.
        </p>
      </div>

      <div className="doctors-container">
        <div className="doctor-card">
          <img src={doctorData.imageUrl} alt={doctorData.name} />
          <div className="card-overlay">
            <h3>{doctorData.name}</h3>
            <p>{doctorData.role}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurDoctors;
